import util from './util';
import {queryBpmFlowByBuildIds, chooseBpmFlowById, startInstance} from './api';
import {mapState} from 'vuex';
export const approvalMixin = {
    name:'approvalMixin',
    data () {
        return {
            approvalProcessTime:0,
            startInstanceTime:0
        }
    },
    computed:{
        ...mapState({
            common:state=>state.common
        })
    },
    methods: {
        // 发起审批流程
        approvalProcess(data,callback,failFun){
            let params ={
                companyId:this.common.marketInfo.cityId,
                subProjectIds:this.common.marketInfo.id,
                pid:data.pid,
                bizFlag:data.bizFlag
            }
            let headers = {
                "Access-channel": "saas_rst",
                'companyId':this.common.marketInfo.cityId
            }
            queryBpmFlowByBuildIds(params,headers).then(res=>{
            console.log(res)
            if(res.code === 1000 && res.data){
                this.approvalProcessTime = 0;
                //this.startInstance(res.data[0],data,callback,failFun)
                this.chooseBpmFlowById(res.data[0],data,callback,failFun)
            }else{
                this.approvalProcessTime += 1;
                if(this.approvalProcessTime < 3){
                this.approvalProcess(data.pid,data.bizFlag,data)
                }else{
                    typeof failFun == 'function' && failFun()
                // this.canClick = true
                // util.hideLoading()
                // util.showToast('提交失败')
                }
            }
            })
        },
        chooseBpmFlowById(msg,data,callback,failFun){
            var params ={
                id:msg.id,
                pid:data.pid,
                bizFlag:data.bizFlag,
                conditionsData:msg.nodeProfile
            }
            let headers = {
                "Access-channel": "saas_rst",
                'companyId':this.common.marketInfo.cityId
            }
            chooseBpmFlowById(params,headers).then(res=>{
                if(res.code === 1000 && res.data){
                    console.log('1111')
                    this.startInstance(res.data,data,callback,failFun)
                }else{
                    this.startInstanceTime += 1;
                    if(this.startInstanceTime < 3){
                        this. chooseBpmFlowById(msg,data,callback,failFun)
                    }else{
                        typeof failFun == 'function' && failFun()
                    }
                }
            })

        },

        startInstance(msg,data,callback,failFun){
            let params = {
            flowPk:msg.id,
            flowId:msg.flowId,
            promoter:data.promoter,//发起人id
            // promoterName:this.common.userTenantInfo.userName,
           // promoterName:this.userName,//发起人名称(用户填的名称)
            companyId:this.common.marketInfo.cityId,
            data:JSON.stringify(data),
            param:"",
            subject:"",
            bsid:data.bsid,
            nodeList:msg.nodeList,
            channel:'SAMQI',
            platform:'SAAS',
            timestamp:new Date().getTime(),
            sign:this.$md5('mhxzkhl990' + "SAAS" + (new Date().getTime() + Number(this.common.marketInfo.cityId)) + 'ncbbsss123')
            }
            // if(data.userName) {  //有填写用户名用填写的用户名
            //    params.promoterName = data.userName;
            // }
            if (Object.keys(this.common.userTenantInfo).length > 0) {
                params.promoterName = this.common.userTenantInfo.userName
            } else {
                params.promoterName = this.common.userInfo.userName
            }
            let headers = {
            "Access-channel": "saas_rst",
            'companyId':this.common.marketInfo.cityId
            }
            startInstance(params,headers).then(res=>{
            console.log(res)
            this.canClick = true
            if(res.code === 1000){
                this.startInstanceTime = 0;
                // util.hideLoading()
                // this.loadParkLot()
                typeof callback == 'function' && callback()
            }else{
                this.startInstanceTime += 1;
                if(this.startInstanceTime < 3){
                    this.startInstance(msg,data)
                }else{
                    // util.hideLoading()
                    // util.showToast('提交失败')
                    typeof failFun == 'function' && failFun()
                }
            }
            })
        },
    }
}
